import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import dcqService from '../../../services/dcqService';
import participantService from '../../../services/participantService';
import { validateDCQ } from './validation/validateDCQ';

function useCreateDCQForm({ participantID, location, navigate }) {
  const [dcqData, setDcqData] = useState({
    type: '',
    action: '',
    participant: '',
    initial_value: '',
    new_value: '',
    requested_change: '',
    reason_for_change: '',
  });
  const [displayParticipantId, setDisplayParticipantId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const displayId = params.get('displayId');

    if (participantID) {
      setDcqData(prev => ({ ...prev, participant: participantID }));
      if (displayId) {
        setDisplayParticipantId(displayId);
      } else {
        setIsLoading(true);
        participantService.getParticipant(participantID)
          .then(response => {
            if (response?.participant_id) {
              setDisplayParticipantId(response.participant_id);
            }
          })
          .catch(() => toast.error('Error loading participant details'))
          .finally(() => setIsLoading(false));
      }
    }
  }, [location, participantID]);

  const handleInputChange = (e) => {
    setDcqData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { trimmed, errors: validationErrors } = validateDCQ(dcqData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Please fix the highlighted fields.');
      return;
    }

    try {
      const result = await dcqService.createDCQ(trimmed);
      if (result?.id) {
        toast.success('DCQ created successfully!');
        const referrer = sessionStorage.getItem('dcqReferrer') || document.referrer;
        const matches = referrer.match(/\/studies\/(\d+)\/sites\/(\d+)\/participant/);
        if (matches) {
          const [, studyId, siteId] = matches;
          setTimeout(() => navigate(`/studies/${studyId}/sites/${siteId}/participant/${participantID}/`), 2000);
          return;
        }
        setTimeout(() => navigate(-1), 2000);
      } else {
        toast.error('Failed to create DCQ. Please try again.');
      }
    } catch (err) {
      console.error('Error creating DCQ:', err);
      toast.error('An unexpected error occurred. Please try again.');
    }
  };

  return { dcqData, errors, displayParticipantId, isLoading, handleInputChange, handleSubmit };
}

export default useCreateDCQForm;